import classNames from "classnames";

import { TestProps } from "shared/types";
import { toSnakeCase } from "shared/utils";

interface LabelProps
  extends React.ComponentPropsWithoutRef<"label">, TestProps {
  text: React.ReactNode;
}

const Label = ({
  text,
  id,
  htmlFor,
  className = "text-gray-500",
  testId,
  ...otherProps
}: LabelProps) => {
  if (text === undefined || text === "") return null;

  const forIdToUse = typeof text === "string" ? toSnakeCase(text) : undefined;

  return (
    <label
      {...otherProps}
      id={id}
      className={classNames("block pl-1 text-base sm:text-sm mb-1", className)}
      htmlFor={htmlFor ?? forIdToUse}
      data-testid={testId}
    >
      {text}
    </label>
  );
};

export default Label;
